function selectVariant(el) {
  document.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('selected'); });
  el.classList.add('selected');

  var variantId = el.getAttribute('data-variant-id');
  var select = document.getElementById('variant-select');
  if (select && variantId) { select.value = variantId; }

  var image = el.getAttribute('data-image');
  var mainImage = document.getElementById('mainImage');
  if (image && mainImage) { mainImage.src = image; }

  var price = el.getAttribute('data-price');
  var priceEl = document.getElementById('priceMain');
  if (price && priceEl) { priceEl.textContent = price; }

  var available = el.getAttribute('data-available') === 'true';
  var btn = document.getElementById('addToCartBtn');
  var btnLabel = document.getElementById('addToCartLabel');
  if (btn && btnLabel) {
    btn.disabled = !available;
    btnLabel.textContent = available ? 'Add to cart' : 'Coming soon';
  }

  var label = el.closest('.product-info').querySelector('.field-label');
  if (label) {
    var base = label.textContent.split(' — ')[0];
    label.textContent = base + ' — ' + el.getAttribute('title') + (available ? '' : ' (coming soon)');
  }
}

function stepQty(delta) {
  var el = document.getElementById('qty');
  var input = document.getElementById('qtyInput');
  if (!el || !input) { return; }
  var next = Math.max(1, parseInt(el.textContent, 10) + delta);
  el.textContent = next;
  input.value = next;
}
